/**
 * @param value (number) - The value to convert to BigInt, if it's a float, it will be rounded down
 * @returns (bigint) - The value converted to BigInt
 */
export const convertToBigInt = (value: number): bigint => BigInt(Math.floor(value));
